module.exports = __webpack_public_path__ + "public/img/Kepuasan Pelanggan untuk Staf Toko.60107886.png";